import React, { useState } from 'react';

const tabItems = [
  {
    id: 1,
    title: 'Owner',
    path: '/other/chassis/owner',
  },
  {
    id: 2,
    title: 'Type',
    path: '/other/chassis/type',
  },
  {
    id: 3,
    title: 'Size',
    path: '/other/chassis/size',
  },
];

const ContainerTabs = ({ activeTab, button }) => {
  const [isTabActive, setIsTabActive] = useState(activeTab);

  return (
    <div className="card mb-15 d-flex flex-row align-items-center justify-content-between p-3 w-100">
      {/*  Sub Header Tabs*/}
      <ul className="nav nav-compact" role="tablist">
        {tabItems.map((tabItem) => (
          <li className="nav-item" key={tabItem.id}>
            <a
              href={tabItem.path}
              className={`nav-link ${
                isTabActive === tabItem.title ? ' active' : ''
              }`}
              onClick={() => setIsTabActive(tabItem.title)}
            >
              {tabItem.title}
            </a>
          </li>
        ))}
      </ul>

      {/* CTA BUTTON */}
      {button}
    </div>
  );
};

export default ContainerTabs;
